import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const COMPARISON_CHIP_LINE_HEIGHT = "1.3";
const STICKY_BAR_Z_INDEX = 5;
const REFRESH_BUTTON_HEIGHT = "32px";
const DISABLED_OPACITY = "0.6";

export const useStyles = makeStyles({
  bar: {
    position: "sticky",
    top: "0",
    zIndex: STICKY_BAR_Z_INDEX,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: designTokens.spacing[4],
    padding: `${designTokens.spacing[4]} 72px`,
    backgroundColor: designTokens.neutral.white,
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
    boxShadow: "0 2px 8px rgba(19,46,83,0.06)",
  },
  filterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[6],
    flexWrap: "nowrap",
  },
  entityGroup: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[5],
    flexWrap: "nowrap",
    minWidth: "0",
  },
  dateSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: designTokens.spacing[2],
  },
  entitySection: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    minWidth: "0",
  },
  label: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.bold,
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.wide,
    color: designTokens.neutral[500],
    whiteSpace: "nowrap",
  },
  separator: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[500],
  },
  viewModeGroup: {
    display: "flex",
    gap: designTokens.spacing[2],
    alignItems: "center",
    justifyContent: "flex-end",
    flexShrink: "0",
    minWidth: "max-content",
  },
  segmentedGroup: {
    display: "flex",
    border: `1px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius.sm,
    overflow: "hidden",
  },
  segmentedBtn: {
    fontFamily: "inherit",
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    border: "none",
    cursor: "pointer",
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[700],
    transition: `background-color ${designTokens.transition.base}, color ${designTokens.transition.base}`,
    whiteSpace: "nowrap",
    textAlign: "center",
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
      zIndex: "1",
    },
  },
  segmentedBtnLeft: {
    borderRight: `1px solid ${designTokens.neutral[300]}`,
  },
  segmentedBtnRight: {},
  segmentedBtnActive: {
    backgroundColor: designTokens.primary[900],
    color: designTokens.neutral.white,
    ":hover": {
      backgroundColor: designTokens.primary[900],
    },
  },
  infoIconButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: designTokens.spacing[1],
    background: "none",
    border: "none",
    cursor: "pointer",
    color: designTokens.neutral[500],
    borderRadius: designTokens.borderRadius.sm,
    transition: `color ${designTokens.transition.fast}`,
    ":hover": {
      color: designTokens.neutral[700],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  adminControls: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },

  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    fontFamily: designTokens.fontFamily,
    backgroundColor: designTokens.accent[500],
    color: designTokens.neutral.white,
    border: "none",
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[4]}`,
    height: REFRESH_BUTTON_HEIGHT,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
    cursor: "pointer",
    transition: `background ${designTokens.transition.fast}`,
    whiteSpace: "nowrap",
    ":hover:not(:disabled):not([aria-disabled='true'])": {
      backgroundColor: designTokens.accent[600],
    },
    ":active:not(:disabled):not([aria-disabled='true'])": {
      backgroundColor: designTokens.accent[700],
    },
    ":disabled": {
      backgroundColor: designTokens.neutral[300],
      cursor: "not-allowed",
      opacity: DISABLED_OPACITY,
    },
    "&[aria-disabled='true']": {
      backgroundColor: designTokens.neutral[300],
      cursor: "not-allowed",
      opacity: DISABLED_OPACITY,
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },

  wideToast: {
    width: "fit-content",
    maxWidth: "440px",
  },

  wideToastTitle: {
    whiteSpace: "nowrap",
  },

  comparisonChip: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "200px",
    backgroundColor: "rgba(3,159,184,0.08)",
    color: designTokens.accent[500],
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    lineHeight: COMPARISON_CHIP_LINE_HEIGHT,
    textAlign: "center",
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    borderRadius: designTokens.borderRadius.lg,
    border: `1px solid rgba(3,159,184,0.2)`,
    whiteSpace: "nowrap",
    cursor: "default",
    userSelect: "none",
  },
  firstRowfilterBarWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
  secondRowFilterBarWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
});
